import React from 'react';
import { Filter, TextInput, List, Datagrid, TextField, BooleanField } from 'react-admin';
import ScreenDescription from '../ScreenDescription';

const FilterByName = (props) => (
  <Filter {...props}>
    <TextInput label="Buscar" source="name" alwaysOn />
  </Filter>
);

const BlockList = props => (
  <>
    <ScreenDescription>
      Blocos agrupam mensagens pelo <strong>fluxo funcional do produto</strong> que as originou (ex: Suporte, Cobrança / PritPay).
      É o nível "Consolidado" da tela de Volumetria. Toda fonte de mensagem nova (template ou mensagem livre) nasce automaticamente
      no bloco "Outros" até ser reclassificada em Fontes de mensagem. Desativar um bloco não apaga histórico, só impede que ele
      seja escolhido em novas reclassificações.
    </ScreenDescription>
    <List
      {...props}
      filters={<FilterByName />}
      sort={{ field: 'name', order: 'ASC' }}
      bulkActionButtons={false}
    >
      <Datagrid rowClick="edit">
        <TextField source="name" label="Nome" />
        <TextField source="key" label="Chave" />
        <BooleanField source="active" label="Ativo" />
      </Datagrid>
    </List>
  </>
);

export default BlockList;
